var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[(_vm.noData)?_c('div',{staticClass:"presc--fullscreen"},[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":"primary"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }